import { AppNS } from 'app';
import { useAuthStore } from 'app/core/store_v2/auth';
import { isAgency, isBackoffice, isClient, isGeneral } from 'app/helpers/userRoles';

export const getUserRoleInfo = () => {
  const currentUser = useAuthStore.getState().currentUser as unknown as AppNS.User;
  return {
    isClient: isClient(currentUser),
    isAgency: isAgency(currentUser),
    isAdmin: isBackoffice(currentUser) || isGeneral(currentUser),
    currentUser,
  };
};

export const getRoleUrlPrefix = (): string => {
  const info = getUserRoleInfo();
  if (info.isAgency) {
    return '/agency';
  }
  if (info.isAdmin) {
    return '/admin';
  }
  return '';
};

export const getMessagingLink = (threadId: string, recipientId: string): string => {
  return `${getRoleUrlPrefix() || '/client'}/messaging/create-thread/${recipientId}/${threadId}`;
};
